import React from "react";
import { Helmet } from "react-helmet-async";

const SEOHead = ({ seoData }) => {
  if (!seoData) return null;

  // Always use livneu.levelstair.com for canonical
  const canonicalUrl = seoData.url.startsWith("https://livneu.levelstair.com")
    ? seoData.url
    : `https://livneu.levelstair.com${seoData.url.startsWith("/") ? seoData.url : "/"}`;

  const {
    title,
    description,
    image,
    url,
    keywords,
    type = "website"
  } = seoData;

  // Create structured data for Livneu
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Livneu",
    url: "https://livneu.levelstair.com",
    logo: "https://livneu.levelstair.com/ShareImage.png",
    description: "A community where VTubers and riggers come together to create magical content and build lasting friendships",
    audience: {
      "@type": "Audience",
      audienceType: "VTubers, Riggers, Content Creators, Artists, Anime Enthusiasts"
    },
    knowsAbout: [
      "VTuber Technology",
      "Character Rigging", 
      "Live2D Animation",
      "3D Character Modeling",
      "Streaming Technology",
      "Content Creation",
      "Digital Art",
      "Anime Culture"
    ]
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Livneu" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />

      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Livneu Team" />
      <meta name="theme-color" content="#FFD700" />
      <meta name="msapplication-TileColor" content="#FFD700" />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default SEOHead;
